




































import Vue from 'vue';
import PoseIcon from '@/components/PoseIcon.vue';
import Rating from '@/components/Rating.vue';

const difficulty = require('@/data/difficulty.json');

export default Vue.extend({
  name: 'PracticeListing',
  components: {
    PoseIcon,
    Rating,
  },
  props: {
    description: String,
    difficulty: String,
    duration: Number,
    name: String,
    poseAlt: String,
    poseName: String,
    poseSide: String,
    poses: Number,
    practiceStyle: String,
    rating: Number,
    reviews: Number,
    teacherCertified: Boolean,
    teacherName: String,
    teacherUsername: String,
    uri: String,
  },
  data() {
    return {
      cleanDescription: '',
      difficultyMap: difficulty,
    };
  },
  filters: {
    minutes(value: number) {
      if (!value) {
        return '';
      }

      return Math.ceil(value / 60);
    },
    trim(value: string) {
      if (!value) {
        return '';
      }

      return value.trim();
    },
  },
});
